module.exports = __webpack_public_path__ + "img/firstDeposit.9baa3025.svg";